const NOTIFICATION_NAME = {
  PRODUCT_ADDED_TO_CART: 'product-added-to-cart',
  GENERIC_FORMULA_SWITCHED_IN_CART: 'generic-formula-switched-in-cart'
};

const subscriptions = Object.values(NOTIFICATION_NAME).reduce((acc, notificationName) => {
  acc[notificationName] = new Set();

  return acc;
}, {});

const getCallbacksByNotificationName = notificationName => {
  const callbacks = subscriptions[notificationName];

  if (!callbacks) {
    throw Error(`Unregistered notification ${notificationName}`);
  }

  return callbacks;
};

export const NotificationService = {
  NOTIFICATION_NAME,
  dispatch: (notificationName, payload) => {
    getCallbacksByNotificationName(notificationName).forEach(callback => {
      callback(payload);
    });
  },
  subscribe: (notificationName, callback) => {
    getCallbacksByNotificationName(notificationName).add(callback);
  },
  unsubscribe(notificationName, callback) {
    getCallbacksByNotificationName(notificationName).delete(callback);
  }
};
